import { getStreakFrames } from 'services/streaksService';

import { streakStore } from './streakStore';

/** Seats mounting together (a table opening) share one request. */
const BATCH_DELAY_MS = 50;
/** player-api's GET /streaks/frames limit. */
const MAX_PER_REQUEST = 10;
/**
 * A seat remounting (layout, orientation) within this long does not ask
 * again. Changes after the answer arrive as `gotStreakFrame` pushes.
 */
const RECENT_MS = 10_000;

const pending = new Set<string>();
const askedAt = new Map<string, number>();
let timer: ReturnType<typeof setTimeout> | null = null;

function flush() {
  timer = null;
  const guids = Array.from(pending);
  pending.clear();
  for (let i = 0; i < guids.length; i += MAX_PER_REQUEST) {
    const chunk = guids.slice(i, i + MAX_PER_REQUEST);
    getStreakFrames(chunk)
      .then((frames) => streakStore.acceptSeatFrames(frames))
      .catch(() => {
        // No frame shows; the next time the seat mounts it asks again.
        chunk.forEach((guid) => askedAt.delete(guid));
      });
  }
}

/**
 * Asks for a seated player's frame (EN-11164): when a table opens or a new
 * player sits. Batched, and not repeated for a GUID asked about recently.
 */
export function requestSeatFrame(guid: string) {
  const now = Date.now();
  const last = askedAt.get(guid);
  if (last !== undefined && now - last < RECENT_MS) return;
  askedAt.set(guid, now);
  pending.add(guid);
  if (!timer) timer = setTimeout(flush, BATCH_DELAY_MS);
}

/** Sign-out or a different player. */
export function resetSeatFrameLoader() {
  if (timer) clearTimeout(timer);
  timer = null;
  pending.clear();
  askedAt.clear();
}
